import { Provider } from 'react-redux'
import { getStore } from '../../redux/store'
import PropTypes from 'prop-types'
import React from 'react'

const ReduxContainer = props => {
  return <Provider store={getStore()}>{props.children}</Provider>
}

ReduxContainer.propTypes = {
  children: PropTypes.node
}
export default ReduxContainer
